import Vue from 'vue'
import Vuex from 'vuex'
import { accountLogin, getUserIndex } from '@/api/user'
import { getAuth, saveAuth, clearAuth } from '@/utils/auth'
import { parseJwtPayload } from '@/utils/session'
import websocket from './websocket'

Vue.use(Vuex)

const saved = getAuth()

function buildUserFromProfile(data = {}, fallback = {}) {
  const jwtPayload = parseJwtPayload(fallback.jwtToken)
  return {
    id: data.id || jwtPayload.user_id || fallback.id || null,
    name: data.nickname || data.username || data.mobile || fallback.name || '',
    role: data.group_name || fallback.role || '商务专员',
    avatar: data.avatar || data.full_avatar || fallback.avatar || ''
  }
}

export default new Vuex.Store({
  state: {
    appName: '外勤蜂客服端',
    token: saved ? saved.token : '',
    notifyCount: 12,
    user: saved ? saved.user : { id: null, name: '', role: '商务专员' },
    badges: {
      consultPool: 8,
      sessions: 12,
      dispatch: 6
    }
  },
  getters: {
    appTitle: state => state.appName,
    isLoggedIn: () => {
      const auth = getAuth()
      return !!auth
    }
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = { id: null, name: '', role: '商务专员' }
      clearAuth()
    },
    SET_BADGE(state, { key, value }) {
      state.badges[key] = value
    },
    SET_NOTIFY_COUNT(state, value) {
      state.notifyCount = value
    }
  },
  actions: {
    login({ commit, dispatch }, payload) {
      return accountLogin(payload).then((res) => {
        const data = res.data || {}
        const token = data.token || (data.userinfo && data.userinfo.token)
        if (!token) {
          return Promise.reject(new Error('登录成功但未返回 token'))
        }
        const userinfo = data.userinfo || {}
        const jwtPayload = parseJwtPayload(data.jwtToken)
        const user = buildUserFromProfile(userinfo, {
          jwtToken: data.jwtToken,
          name: payload.account,
          id: jwtPayload.user_id || userinfo.id || null
        })
        saveAuth(token, user)
        commit('SET_AUTH', { token, user })
        return dispatch('fetchUserInfo').then(() => {
          dispatch('websocket/connectAppWebSocket').catch(() => {})
          return res
        })
      })
    },
    fetchUserInfo({ commit, state }) {
      if (!state.token) return Promise.resolve(null)
      return getUserIndex().then((res) => {
        const data = res.data || {}
        if (!data.id) return state.user
        const user = buildUserFromProfile(data, state.user)
        saveAuth(state.token, user)
        commit('SET_AUTH', { token: state.token, user })
        return user
      }).catch(() => state.user)
    },
    logout({ commit, dispatch }) {
      dispatch('websocket/closeWebSocket')
      commit('CLEAR_AUTH')
    },
    setBadge({ commit }, payload) {
      commit('SET_BADGE', payload)
    }
  },
  modules: {
    websocket
  }
})
